// extracted by mini-css-extract-plugin
export var container = "StakeInput-module--container--75232";
export var input = "StakeInput-module--input--cb11f";
export var wrapper = "StakeInput-module--wrapper--f46ef";